// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2Gy0z","name":"ConsentHeader_name__10pKT","birthday":"ConsentHeader_birthday__3Jwvx","skeleton":"ConsentHeader_skeleton__nRJYU"};